import {
    useLocation,
} from "react-router-dom";

function GetParamsObject() {
    const params = new URLSearchParams(useLocation().search)

    const paramsObject = {}
    params.forEach((value, key) => {
        try {
            if (key.indexOf('date') !== -1) {
                paramsObject[key] = JSON.parse(value)
                //paramsObject[key].min = new Date(paramsObject[key].min)
                //paramsObject[key].max = new Date(paramsObject[key].max)
            } else {
                paramsObject[key] = value
            }
        } catch (e) {
            paramsObject[key] = value
        }
    })

    return paramsObject
}

function ObjectToParams(object) {
    let params = ''

    for (let key in object) {
        params += params.length === 0 ? '?' : '&'
        if (typeof(object[key]) === 'object') {
            params += key + '=' + JSON.stringify(object[key])
        } else {
            params += key + '=' + object[key]
        }
    }

    return params
}

export {
    GetParamsObject,
    ObjectToParams,
}
